import type { ReactNode } from 'react';

/**
 * De kaarten van een tabblad, onder elkaar, met dezelfde rand rechts als de
 * tabbladen van Instellingen (`max-width: 1120px`). Twee kaarten die naast elkaar
 * horen, zetten hun eigen raster binnen deze kolom.
 */
export function TabColumn({ children }: { children: ReactNode }) {
    return <div className="flex max-w-[1120px] flex-col gap-[14px]">{children}</div>;
}
